module.exports = __webpack_public_path__ + "media/images/infinite_star-bd9896ec.svg";